import { RangerSourceMapServiceBase } from './ranger-source-map.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { addPageSpecificationParameters, appendSerialisedHttpParams, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, markAsBackgroundServiceCall } from '@scisys-uim/uim-common';
import { RangerSourceMap } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class RangerSourceMapService extends RangerSourceMapServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }


  public findByFullFiltersExtended(filters: any, pageSpec?: PageSpecification, reduced: boolean = true, backgroundServiceCall: boolean = false): Observable<HateoasMultipleResponseObject<RangerSourceMap>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<RangerSourceMap>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params,
      headers: backgroundServiceCall ? markAsBackgroundServiceCall() : null
    }));
  }
}



